<app-banner>
    @if (success !== undefined && message !== undefined) {
        <div [class]="success ? 'text-center text-success' : 'text-center text-danger'">
            <p>{{ message }}</p
            ><p>
                @if (success) {
                    <a i18n="@@emailVerification.goToLogin" class="button button-primary body-link mt-4 text-center" href="/login"
                        >Ga naar login</a
                    >
                }
            </p></div
        >
    }
</app-banner>
